import { Paper } from '@mui/material';
import React from 'react';

class StickyNote extends React.Component {
  static defaultProps = {
    title: 'Info2',
    text: 'This is the text',
    rotated: '', //possible values: "", "+", "-"
  };

  render() {
    return (
      <div className='text-center m-1 p-1 d-flex align-items-center justify-content-center'>
        <Paper
          elevation={6}
          className={'p-1 stickynote stickynote-sticky '}
        >
          {this.props.title ? <div>{this.props.title}</div> : null}
          {this.props.text && <div className='text-left'>{this.props.text}</div>}
        </Paper>
      </div>
    );
  }
}

export default StickyNote;
